import spacing from '@tcp/core/styles/themes/TCP/spacing';

export const CARD_INNER_PADDING = {
  MOBILE: spacing.ELEM_SPACING.MED,
  TABLET: spacing.ELEM_SPACING.XL,
  DESKTOP: spacing.ELEM_SPACING.XL,
};

export const CARD_INNER_PADDING_BOTTOM = {
  MOBILE: spacing.ELEM_SPACING.XL,
  TABLET: spacing.ELEM_SPACING.XL,
  DESKTOP: spacing.ELEM_SPACING.XL,
};

export const CARD_MARGIN = {
  MOBILE: spacing.ELEM_SPACING.MED,
  TABLET: spacing.ELEM_SPACING.LRG,
  DESKTOP: spacing.ELEM_SPACING.LRG,
};

export const REVIEW_CARD_MARGIN = {
  MOBILE: spacing.ELEM_SPACING.SM,
  TABLET: spacing.ELEM_SPACING.MED,
  DESKTOP: spacing.ELEM_SPACING.MED,
};

export const CARD_CONTENT_PADDING = {
  TOP: spacing.ELEM_SPACING.MED_1,
};

export const ORDER_LEDGER = {
  ROW: {
    MARGIN_BOTTOM: spacing.ELEM_SPACING.MED,
    MARGIN_BOTTOM_1: '6px',
  },
  SUBMIT_CONTAINER: {
    MARGIN_TOP: {
      LARGE: spacing.ELEM_SPACING.LRG,
    },
    MARGIN_BOTTOM: {
      LARGE: spacing.ELEM_SPACING.LRG,
    },
  },
  DISCLAIMER: {
    MARGIN_TOP: {
      MOBILE: spacing.ELEM_SPACING.MED,
      TABLET: spacing.ELEM_SPACING.LRG,
      DESKTOP: spacing.ELEM_SPACING.LRG,
    },
  },
  LOYALTY_BANNER: {
    PADDING: '0px',
  },
  COLLAPSIBLE_HEADER: {
    PADDING_LEFT: '0px',
    PADDING_TOP: '0px',
  },
  ORDER_SPC: {
    PADDING_TOP: {
      MOBILE: spacing.ELEM_SPACING.LRG,
      TABLET: spacing.ELEM_SPACING.XL,
      DESKTOP: spacing.ELEM_SPACING.XL,
    },
  },
  TAX: {
    PADDING_BOTTOM: spacing.ELEM_SPACING.MED,
  },
};

export const SPC_CONTENT_WRAPPER = {
  MARGIN_BOTTOM: '142px',
};

export const ESTIMATED_TOTAL = {
  MARGIN_BOTTOM: {
    MOBILE: spacing.ELEM_SPACING.LRG,
    TABLET: spacing.ELEM_SPACING.XL,
  },
};

export const MY_BAG = {
  IMG_WIDTH: {
    MOBILE: '58px',
    TABLET: '58px',
    DESKTOP: '63px',
  },
  IMG_HEIGHT: {
    MOBILE: '72px',
    TABLET: '72px',
    DESKTOP: '76px',
  },
};
